<template>
  <div :class="['navbar-area', { 'is-sticky': isSticky }]">
    <div class="vumy-nav">
      <div class="container">
        <nav class="navbar navbar-expand-lg navbar-dark">
          <router-link class="navbar-brand" to="/">
            <img src="../../assets/images/logo.png" alt="Fontes Business - Desenvolvimento de Software">
          </router-link>

          <div
              class="navbar-toggler"
              @click="show = !show"
              :aria-pressed="show ? 'true' : 'false'"
              v-bind:class="{ show: button_show_state }"
              v-on:click="button_show_state = !button_show_state"
          >
            <span class="icon-bar top-bar"></span>
            <span class="icon-bar middle-bar"></span>
            <span class="icon-bar bottom-bar"></span>
          </div>

          <div class="collapse navbar-collapse" :class="{ show: show }">
            <ul class="navbar-nav">
              <li class="nav-item">
                <router-link to="/" class="nav-link">Home</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/about-us" class="nav-link">Sobre</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/services" class="nav-link">Serviços</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/fontes-business-one" class="nav-link">One</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/erp-escolar" class="nav-link">Escola</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/nutraxis" class="nav-link">Nutricionistas</router-link>
              </li>
              <li class="nav-item">
                <router-link to="/pila" class="nav-link">Pila</router-link>
              </li>
            </ul>
          </div>

          <div class="others-option">
            <a href="https://wa.me/5554992302401?text=Olá! Gostaria de saber mais sobre os serviços da Fontes Business"
               target="_blank"
               class="btn-style-one green-color"
               rel="noopener noreferrer">
              WhatsApp
            </a>
          </div>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Navbar',
  data() {
    return {
      isSticky: false,
      show: false,
      button_show_state: false,
    };
  },
  mounted() {
    const that = this;
    window.addEventListener("scroll", () => {
      let scrollPos = window.scrollY;
      if (scrollPos >= 100) {
        that.isSticky = true;
      } else {
        that.isSticky = false;
      }
    });
  },
}
</script>

<style scoped>
/* ===== NAVBAR BASE ===== */
.navbar-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 999;
  padding: 20px 0;
  transition: all 0.3s ease;
}

.navbar-area .vumy-nav {
  background: transparent;
  transition: all 0.3s ease;
}

.navbar-area.is-sticky {
  position: fixed;
  top: 0;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  padding: 10px 0;
}

.navbar-area.is-sticky .vumy-nav {
  background: transparent;
}

/* ===== LINKS DO MENU ===== */
.navbar-area .nav-link {
  color: #ffffff !important;
  font-weight: 500;
  padding: 8px 16px !important;
  transition: all 0.3s ease;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.navbar-area .nav-link:hover {
  color: #C5BFFF !important;
  transform: translateY(-2px);
}

.navbar-area.is-sticky .nav-link {
  color: #1a1a2e !important;
  text-shadow: none;
}

.navbar-area.is-sticky .nav-link:hover {
  color: #6D5DFC !important;
}

/* ===== ÍCONES DO HAMBURGER ===== */
.navbar-toggler .icon-bar {
  background-color: #ffffff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.navbar-area.is-sticky .navbar-toggler .icon-bar {
  background-color: #1a1a2e !important;
  box-shadow: none;
}

/* ===== BOTÕES ===== */
.btn-style-one {
  padding: 10px 20px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  white-space: nowrap;
}

/* BOTÃO WHATSAPP - FIX ESPECÍFICO */
.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: 2px solid #25D366;
  color: white !important;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
  display: inline-flex !important;
  align-items: center !important;
  gap: 0 !important;
}

/* Força o ícone a ficar do lado do texto */
.btn-style-one.green-color i.flaticon-whatsapp {
  margin-right: 8px !important;
  margin-left: 0 !important;
  display: inline-block !important;
  font-size: 18px;
}

/* Remove qualquer pseudo-elemento que possa estar causando problema */
.btn-style-one.green-color i.flaticon-whatsapp::before {
  margin: 0 !important;
  padding: 0 !important;
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  color: white !important;
}

/* ===== LOGO ===== */
.navbar-brand img {
  max-height: 50px;
  transition: all 0.3s ease;
  filter: brightness(0) invert(1);
}

.navbar-area.is-sticky .navbar-brand img {
  max-height: 45px;
  filter: none;
}

/* ===== RESPONSIVE ===== */
.others-option {
  display: flex;
  align-items: center;
}

@media (max-width: 991px) {
  .navbar-area {
    background: rgba(10, 10, 26, 0.98) !important;
    backdrop-filter: blur(10px);
    padding: 15px 0;
  }

  .others-option {
    margin-top: 15px;
    flex-direction: column;
    width: 100%;
    align-items: flex-start;
    padding: 0 20px;
  }

  .btn-style-one {
    width: auto;
  }

  .btn-style-one.green-color {
    display: none !important;
  }

  .navbar-collapse {
    background: rgba(10, 10, 26, 0.95);
    padding: 20px;
    border-radius: 12px;
    margin-top: 15px;
  }

  .nav-link {
    padding: 12px 16px !important;
  }
}

/* BOTÃO WHATSAPP */
.btn-style-one.green-color {
  background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
  border: 2px solid #25D366;
  color: white !important;
  box-shadow: 0 4px 15px rgba(37, 211, 102, 0.3);
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
}

.btn-style-one.green-color .btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.btn-style-one.green-color .btn-icon i {
  font-size: 18px;
  line-height: 1;
}

.btn-style-one.green-color .btn-text {
  display: inline-block;
  line-height: 1;
}

.btn-style-one.green-color:hover {
  background: linear-gradient(135deg, #128C7E 0%, #075E54 100%);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
}
</style>